import { render } from "./AvaliacaoFisicaFormulario.vue?vue&type=template&id=433d7fcd&scoped=true"
import script from "./AvaliacaoFisicaFormulario.vue?vue&type=script&lang=js"
export * from "./AvaliacaoFisicaFormulario.vue?vue&type=script&lang=js"

import "./AvaliacaoFisicaFormulario.vue?vue&type=style&index=0&id=433d7fcd&scoped=true&lang=css"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433d7fcd"]])

export default __exports__